import React from 'react';
import { IFilter, IOnClick } from '../FilterContainer';
import FilterItem from '../FilterItem';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { deviceMinWidth } from '../../constants';

export default function Filter(props: IFilter & IOnClick) {
  const { name, title, options, onClickFilter } = props;
  const isChapterFilterItem = name === 'quotes__chapter' && options?.length > 1;
  const styles = useStyles({
    isChapterFilterItem,
    optionsLength: options?.length,
  });

  const getStyles = () => {
    switch (name) {
      case 'country':
        return styles.country;

      case 'quotes__chapter':
        return styles.chapter;

      default:
        return '';
    }
  };

  const filterWrapperStyles = getStyles();

  return (
    <div className={styles.filter}>
      <FilterItem
        value={''}
        text={''}
        selected={false}
        title={title}
        name={name}
      />
      <div className={filterWrapperStyles}>
        {options?.map((option) => (
          <FilterItem
            name={name}
            isChapterFilterItem={isChapterFilterItem}
            key={`${option.value}-${option.text}`}
            value={option.value}
            text={option.text}
            selected={option.selected}
            onClickFilter={onClickFilter}
          />
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles<
  Theme,
  {
    isChapterFilterItem?: boolean;
    optionsLength?: number;
  }
>((theme) => ({
  filter: {
    marginBottom: 14,
    // [deviceMaxWidth.size500]: {
    //   width: '100%',
    // },
  },

  country: {
    [deviceMinWidth.size501]: {
      overflowY: 'scroll',
      overflowX: 'hidden',
      maxHeight: 475,

      '&::-webkit-scrollbar': {
        width: 5,
      },
      // https://css-tricks.com/custom-scrollbars-in-webkit/
      '&::-webkit-scrollbar-track': {
        marginLeft: 5,
        // backgroundColor: '#FFEFE1',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#E8B07E',
        borderRadius: 5,
      },
    },
  },
  chapter: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    // @ts-ignore
    height: (props) => (props?.optionsLength / 2) * 40 || 0,
    justifyContent: 'space-between',
    marginBottom: 65,
  },
}));
